<template>
  <div class="myinfo">
    <div class="apply-time" v-if="applyStartTime">
      申请时段：<span style="color: red">{{ `${applyStartTime} ~ ${applyEndTime}` }}</span>
    </div>
    <div class="form-content">
      <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="学年学期">
          <a-select v-model="layoutTermName" placeholder="请选择学年学期" allowClear style="width: 391px" @change="changeTerm">
            <a-select-option v-for="(item, index) in termOptions" :key="index" :value="item.layoutTermName">
              {{ item.layoutTermName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="申请课程">
          <a-select
              v-model="applyCourse"
              mode="multiple"
              placeholder="请选择申请课程，可多选"
              allowClear
              :maxTagCount="2"
              :disabled="!layoutTermName"
              style="width: 391px"
          >
            <a-select-option v-for="(item, index) in courseList" :key="index" :value="item.itemValue">
              {{ item.itemText }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="申请事由">
          <a-textarea
              v-model="applyReason"
              placeholder="请输入申请事由"
              rows="5"
              :maxLength="200"
              :disabled="!layoutTermName"
              style="width: 391px" />
        </a-form-item>
        <ChangeUpload
            ref="childRef"
            :fileKey="fileKey"
            :checkFlag="checkFlag"
            :type="type"
            :disabled="!layoutTermName"
            @uploadSuccessList="uploadSuccessList"
            @uploadSuccess="uploadSuccess"
        ></ChangeUpload>

        <a-button type="primary" class="btn btn-info" style="margin-left: 150px" :disabled="!editFlag" @click="submit">提交</a-button>
      </a-form>
    </div>
  </div>
</template>

<script>
import ChangeUpload from '../ChangeUpload.vue'
import {mapState} from 'vuex'

export default {
  name: 'apply',
  components: {
    ChangeUpload
  },
  data: function () {
    return {
      courseList: [],
      termList: [], // 学期列表
      layoutTermName: undefined, // 学年学期
      termOptions: [], // 学期列表
      settingId: '', // 时间配置ID
      editFlag: false, // 是否允许编辑
      currentType: null,
      applyReason: '',
      archiveSpinning: true,
      docUrl: null,
      checkFlag: true,
      type: 0,
      uploading: true,
      uploadingName: '',
      uploadingList: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      applyCourse: [],
      fileKey: '',
      isBetween: true,
      applyStartTime: '', // 申请开始时间
      applyEndTime: '', // 申请结束时间
      docFileList: []
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    // 查询缓考申请时间设置
    this.getApplyConfig()
  },
  methods: {
    uploadSuccessList(val) {
      this.uploadingList = val.toString()
    },
    uploadSuccess(val) {
      this.uploadingName = val.toString()
    },

    // 查询缓考申请时间设置
    getApplyConfig() {
      this.axios.get(`/biz/home/apply/time?type=delay_exam`).then((res) => {
        if (res.success) {
          this.termOptions = res.result
        } else {
          this.termOptions = []
        }
      })
    },

    // 学年学期修改
    changeTerm(value) {
      if (!value) {
        this.settingId = null
        this.applyStartTime = null
        this.applyEndTime = null
        this.editFlag = false
        this.courseList = []
        this.applyCourse = []
        return
      }
      const timeSetting = this.termOptions.find(item => item.layoutTermName === value)
      this.editFlag = true
      this.settingId = timeSetting.id
      this.applyStartTime = timeSetting.startTime
      this.applyEndTime = timeSetting.endTime
      this.applyCourse = []

      // 查询学期课程
      this.axios.get(`/biz/home/apply/course?type=delay_exam&termName=${this.layoutTermName}`).then((res) => {
        this.archiveSpinning = false
        let data = res.result
        data.forEach((item) => {
          item.itemText = item.name
          item.itemValue = item.name
        })
        this.courseList = data
      })
    },

    submit() {
      if (!this.editFlag || !this.applyStartTime) {
        this.$message.warning('当前时间不可申请')
        return
      }
      if (this.applyCourse.length < 1) {
        this.$message.warning('请选择申请课程')
        return
      }
      if (!this.applyReason) {
        this.$message.warning('请输入申请事由')
        return
      }
      // 将字符串分割成数组
      let docList = []
      if (this.uploadingName.includes(',')) {
        const namesArray = this.uploadingName.split(',')
        const urlsArray = this.uploadingList.split(',')
        docList = namesArray.map((name, index) => ({
          docUrl: urlsArray[index],
          docName: name
        }))
      } else if (this.uploadingName) {
        docList.push({
          docUrl: this.uploadingList,
          docName: this.uploadingName
        })
      }

      let params = {
        applyType: 'delay_exam',
        settingId: this.settingId,
        applyCourse: this.applyCourse.join(','),
        applyReason: this.applyReason,
        docList: docList
      }
      this.axios.post(`/biz/home/apply/submit`, params).then((res) => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.applyReason = ''
          this.applyCourse = []
          this.uploadingName = ''
          this.fileKey = Math.random()
          this.$refs.childRef.clearFileList()
        } else {
          this.archiveSpinning = false
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.myinfo {
  display: flex;
  background: #fff;
  padding: 28px;
  padding-top: 46px;
  margin-top: 20px;
  position: relative;
  .apply-time {
    position: absolute;
    top: 16px;
    left: 32px;
    color: #000000;
  }
}
.form-content {
}

.btn {
  background: $bgColor;
  color: #fff;
  width: 120px;
  margin: 20px 0;
}

.btn-info {
  background: $bgColor;
  border: 1px solid $bgColor;
}

.btn-text {
  color: #c4c4c4;
  display: block;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/examPostTabs/apply.vue